import PropTypes from 'prop-types';
import { Card } from '@qga/roo-ui/components';

const PaymentsCard = ({ children, ...props }) => (
  <Card display="block" p={0} pt={5} mb={[5, 8]} {...props}>
    {children}
  </Card>
);

PaymentsCard.propTypes = {
  children: PropTypes.node.isRequired,
  ...Card.propTypes,
};

export default PaymentsCard;
